import { ApiService } from "src/app/services/api.service";
import { HttpHeaders } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Order, OrderTrade, Stocks } from "src/app/models/order";
import { AccountService } from "src/app/services/account.service";
import { environment } from "src/environments/environment";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { formatDate } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
  MatDatepicker,
  MatDateRangePicker,
} from "@angular/material/datepicker";

@Component({
  selector: "app-trades-history",
  templateUrl: "./trades-history.component.html",
  styleUrls: ["./trades-history.component.scss"],
})
export class TradesHistoryComponent implements OnInit {
  isTrade = false;
  userOrders: Order[];
  userTransactions: OrderTrade[];
  searchSubmit = false;
  isOrdersLoading: boolean = false;
  isTradesLoading: boolean = false;
  toggleBool: boolean;
  accList: any;
  symbolCodeName: string;
  selectedAccount;
  records: any = [];
  // orderFilterRequest: OrderFilter = {} as OrderFilter;
  stocksFilter: Stocks = {} as Stocks;
  statusFilter: any;
  typeFilter: any;
  marketFilter: any;

  today = new Date();
  orderRequestFormGroup = new FormGroup({
    relationCode: new FormControl(null, Validators.required),
    symbolCode: new FormControl(""),
    fixStatus: new FormControl(""),
    transactionType: new FormControl(""),
    marketId: new FormControl(""),
    fromDate: new FormControl(
      new Date(this.today.getUTCFullYear(), this.today.getUTCMonth(), 2),
      Validators.required
    ),
    toDate: new FormControl(new Date(), Validators.required),
  });
  transactionRequestFormGroup = new FormGroup({
    relationCode: new FormControl(null, Validators.required),
    symbolCode: new FormControl(""),
    transactionType: new FormControl(""),
    fromDate: new FormControl(
      new Date(this.today.getUTCFullYear(), this.today.getUTCMonth(), 2),
      Validators.required
    ),
    toDate: new FormControl(new Date(), Validators.required),
  });

  @ViewChild("datepickerFooter", { static: false })
  datepickerFooter: ElementRef;
  @ViewChild("datepickerFooter2", { static: false })
  datepickerFooter2: ElementRef;
  @ViewChild("datepicker", { static: false })
  datepicker: MatDateRangePicker<any>;
  @ViewChild("datepicker2", { static: false })
  datepicker2: MatDateRangePicker<any>;

  selectedValue: Date | null = null;
  constructor(
    public translate: TranslateService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.fetchAccounts();
    this.getOrderFilters();
  }
  onOpen(type) {
    this.appendFooter(type);
  }

  PrevDate(limit) {
    let day = new Date().getUTCDate();
    let month = new Date().getUTCMonth();
    let year = new Date().getUTCFullYear();
    if (limit === 0) {
      this.transactionRequestFormGroup.controls["fromDate"].patchValue(
        new Date()
      );
      this.transactionRequestFormGroup.controls["toDate"].patchValue(
        new Date()
      );
    }
    if (limit === 1) {
      this.transactionRequestFormGroup.controls["fromDate"].patchValue(
        new Date(year, month, day - 1)
      );
      this.transactionRequestFormGroup.controls["toDate"].patchValue(
        new Date(year, month, day - 1)
      );
    }
    if (limit === 7) {
      this.transactionRequestFormGroup.controls["fromDate"].patchValue(
        new Date(year, month, day - 7)
      );
      this.transactionRequestFormGroup.controls["toDate"].patchValue(
        new Date()
      );
    }
    if (limit === 30) {
      this.transactionRequestFormGroup.controls["fromDate"].patchValue(
        new Date(year, month - 1, day)
      );
      this.transactionRequestFormGroup.controls["toDate"].patchValue(
        new Date()
      );
    }
    this.transactionRequestFormGroup.controls["fromDate"].patchValue(
      formatDate(
        this.transactionRequestFormGroup.value.fromDate,
        "YYYY-MM-dd",
        "en_US"
      )
    );
    this.transactionRequestFormGroup.controls["toDate"].patchValue(
      formatDate(
        this.transactionRequestFormGroup.value.toDate,
        "YYYY-MM-dd",
        "en_US"
      )
    );

    this.datepicker2.close();
  }
  orderPrevDate(limit) {
    let day = new Date().getUTCDate();
    let month = new Date().getUTCMonth();
    let year = new Date().getUTCFullYear();
    if (limit === 0) {
      this.orderRequestFormGroup.controls["fromDate"].patchValue(new Date());
      this.orderRequestFormGroup.controls["toDate"].patchValue(new Date());
    }
    if (limit === 1) {
      this.orderRequestFormGroup.controls["fromDate"].patchValue(
        new Date(year, month, day - 1)
      );
      this.orderRequestFormGroup.controls["toDate"].patchValue(
        new Date(year, month, day - 1)
      );
    }
    if (limit === 7) {
      this.orderRequestFormGroup.controls["fromDate"].patchValue(
        new Date(year, month, day - 7)
      );
      this.orderRequestFormGroup.controls["toDate"].patchValue(new Date());
    }
    if (limit === 30) {
      this.orderRequestFormGroup.controls["fromDate"].patchValue(
        new Date(year, month - 1, day)
      );
      this.orderRequestFormGroup.controls["toDate"].patchValue(new Date());
    }
    this.orderRequestFormGroup.controls["fromDate"].patchValue(
      formatDate(
        this.orderRequestFormGroup.value.fromDate,
        "YYYY-MM-dd",
        "en_US"
      )
    );
    this.orderRequestFormGroup.controls["toDate"].patchValue(
      formatDate(this.orderRequestFormGroup.value.toDate, "YYYY-MM-dd", "en_US")
    );
    this.datepicker.close();
  }

  private appendFooter(type) {
    const matCalendar = document.getElementsByClassName(
      "mat-datepicker-content"
    )[0] as HTMLElement;
    if (type === 1) {
      matCalendar.appendChild(this.datepickerFooter.nativeElement);
    }
    if (type === 2) {
      matCalendar.appendChild(this.datepickerFooter2.nativeElement);
    }
  }

  fetchAccounts() {
    this.apiService.fetchAccounts().subscribe((res) => {
      if (res) {
        this.accList = res;
        this.selectedAccount = this.accList[0].relationCode;
      }
    });
  }

  getOrderFilters() {
    let filterList;
    this.apiService.fetchOrderFilters().subscribe((res) => {
      filterList = res;
      this.stocksFilter = filterList.Symbols as Stocks;
      this.statusFilter = filterList.Status;
      this.marketFilter = filterList.Markets;
      this.typeFilter = filterList.TransactionTypes;
    });
  }

  credentialsSearchFilter(event: any) {
    this.searchSubmit = true;

    const val = event.target.value.toLowerCase();

    if (val != "") {
      this.toggleBool = true;
    } else {
      this.toggleBool = false;
    }

    this.records = this.stocksFilter.filter((d) => {
      return (
        d.ReutersCode?.toLowerCase().includes(val) ||
        d.SymbolNameA?.toLowerCase().includes(val) ||
        d.SymbolNameE?.toLowerCase().includes(val)
      );
    });
  }
  fetchOrders() {
    let fromDate = formatDate(
      this.orderRequestFormGroup.value.fromDate,
      "YYYY-MM-dd",
      "en_US"
    );
    let toDate = formatDate(
      this.orderRequestFormGroup.value.toDate,
      "YYYY-MM-dd",
      "en_US"
    );

    this.orderRequestFormGroup.value.fromDate = fromDate;
    this.orderRequestFormGroup.value.toDate = toDate;

    this.apiService
      .fetchfilteredOrders({ ...this.orderRequestFormGroup.value, ShowNotActive: true })
      .subscribe((res) => {
        this.isOrdersLoading = true;
        this.userOrders = res as Order[];
      });
  }
  fetchTrades() {
    let fromDate = formatDate(
      this.transactionRequestFormGroup.value.fromDate,
      "YYYY-MM-dd",
      "en_US"
    );
    let toDate = formatDate(
      this.transactionRequestFormGroup.value.toDate,
      "YYYY-MM-dd",
      "en_US"
    );

    this.transactionRequestFormGroup.value.fromDate = fromDate;
    this.transactionRequestFormGroup.value.toDate = toDate;

    this.apiService
      .fetchfilteredTransactions(this.transactionRequestFormGroup.value)
      .subscribe((res) => {
        this.isTradesLoading = true;
        this.userTransactions = res as OrderTrade[];
      });
  }

  selectedOrderRecored(item) {
    if (this.translate.currentLang == "en") {
      this.symbolCodeName = item.SymbolNameE;
    }
    if (this.translate.currentLang == "ar") {
      this.symbolCodeName = item.SymbolNameA;
    }
    this.searchSubmit = false;
    this.orderRequestFormGroup.controls["symbolCode"].patchValue(
      item.SymbolCode
    );
  }
  selectedTransactionRecored(item) {
    this.searchSubmit = false;
    if (this.translate.currentLang == "en") {
      this.symbolCodeName = item.SymbolNameE;
    }
    if (this.translate.currentLang == "ar") {
      this.symbolCodeName = item.SymbolNameA;
    }
    this.transactionRequestFormGroup.controls["symbolCode"].patchValue(
      item.SymbolCode
    );
  }
  xButton() {
    this.symbolCodeName = "";
    this.transactionRequestFormGroup.controls["symbolCode"].patchValue(null);
    this.orderRequestFormGroup.controls["symbolCode"].patchValue(null);
  }
    public maxDate: Date = new Date();

  public disableFutureDates = (d: Date | null): boolean => {
    if (!d) return true;
    const today = new Date();
    const date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const max = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    return date <= max;
  };
}
